import {SettingsDropdownAction} from './enums';
import {PriorityIcon} from '@priority-software/priority-style-react';
import texts from '../../texts';

export const groupOptions = [
    {
        label: texts.edit_group_name_label,
        value: SettingsDropdownAction.edit_group_name,
        icon: PriorityIcon.editFill
    },
    {
        label: texts.delete_label,
        value: SettingsDropdownAction.remove_group,
        icon: PriorityIcon.delete
    },
    {
        label: texts.new_group_label,
        value: SettingsDropdownAction.add_new_group,
        icon: PriorityIcon.gridView
    }
];
export const insightsGroupOptions = [
    {
        label: texts.delete_label,
        value: SettingsDropdownAction.remove_group,
        icon: PriorityIcon.delete
    }
];
